import React, { useState } from "react";
import { fetchUserAttributes } from "aws-amplify/auth";
import { post } from "aws-amplify/api";
// import Typewriter from "typewriter-effect";

import AuthComponent from "./AuthComponent";
import GenderSelPage from "./GenderSelPage";

const HostPage = ({ onClick }) => {
  let [watch, setWatch] = useState(false);

  const watchCollection = async () => {
    setWatch(true);
    try {
      const userAttributes = await fetchUserAttributes();
      alert("Only available in Pro Plan");
      const restOperation = post({
        apiName: "undressStripeApi",
        path: "/cancelsub",
        options: {
          body: {
            userEmail: userAttributes.email,
            plan: "Watch",
          },
        },
      });
      const { body } = await restOperation.response;
    } catch (e) {
      console.error("POST call failed: ", e);
    }
  };
  return (
    <section className="home" id="home">
      {watch && <AuthComponent></AuthComponent>}
      <div className="container">
        {/* <h1 className="title principal">
          AI ❤️ Nudes
 
        </h1>
        <br />
        <br /> */}
        <br />
        <br />
        <h2 className="subtitle" id="subtitle">
          <i>What do you feel like today ?</i>
        </h2>
        <br />
        <GenderSelPage onClick={(gender) => onClick(gender)}></GenderSelPage>
      </div>
    </section>
  );
};

export default HostPage;
